import { useEffect } from "react";
import { trackEvent } from "../utils/analytics";

export const usePromoTracking = (eventId, eventName) => {
  useEffect(() => {
    trackEvent("page_view", {
      event_id: eventId,
      event_name: eventName,
    });
  }, [eventId, eventName]);

  const trackButtonClick = (buttonName) => {
    trackEvent("button_click", {
      event_id: eventId,
      button_name: buttonName,
    });
  };

  return {
    trackButtonClick,
  };
};
